// Traduce un error HTTP crudo a un mensaje que un usuario pueda entender,
// y evita que texto técnico interno (nombres de columnas, "token"/"jwt",
// fragmentos de SQL, stack traces) llegue a mostrarse en pantalla — el
// backend ya debería mandar mensajes seguros, esto es una red de
// seguridad adicional por si algún endpoint no lo hace. Generalización del
// patrón que ya existía solo en reservas.component.ts (getFriendlyError),
// ahora compartido por toda la app en vez de duplicado por componente.
// Exportado para que login.component.ts pueda reutilizar el mismo filtro
// sin duplicar la expresión regular -- no puede usar friendlyError()
// completo ahí porque su regla de "401 = sesión expirada" no aplica al
// propio formulario de login (un 401 ahí es credenciales incorrectas).
export const TECHNICAL_JARGON = /sequel|sql|validationerror|stack|token|jwt|undefined|null/i;
const NETWORK_ISSUE = /timeout|network error|failed to fetch|status 0/i;
const RATE_LIMITED = /too many|rate limit|429/i;

export function friendlyError(error: any, fallback: string): string {
  if (!error || Number(error.status) === 0) {
    return 'No pudimos conectar con el servidor. Verifica tu conexión e inténtalo nuevamente.';
  }
  if (Number(error.status) === 401) {
    return 'Tu sesión expiró. Inicia sesión nuevamente.';
  }
  if (Number(error.status) === 429) {
    return 'Realizaste demasiados intentos seguidos. Espera un momento y vuelve a intentar.';
  }

  const payload = error?.error || {};
  const raw = String(
    typeof error === 'string' ? error : (payload.msg || payload.message || error?.message || '')
  ).trim();

  let base = fallback;
  if (raw && !TECHNICAL_JARGON.test(raw)) {
    base = NETWORK_ISSUE.test(raw)
      ? 'No pudimos conectar con el servidor. Intenta nuevamente en unos segundos.'
      : RATE_LIMITED.test(raw)
        ? 'Realizaste demasiados intentos seguidos. Espera un momento y vuelve a intentar.'
        : raw;
  }

  const retryAfter = Number(payload.retry_after_seconds || 0);
  if (Number.isFinite(retryAfter) && retryAfter > 0) {
    const unit = retryAfter === 1 ? 'segundo' : 'segundos';
    return `${base} Intenta nuevamente en ${retryAfter} ${unit}.`;
  }
  return base;
}
